import { render } from "./DexInputNumber.vue?vue&type=template&id=6fef3d38"
import script from "./DexInputNumber.vue?vue&type=script&lang=js"
export * from "./DexInputNumber.vue?vue&type=script&lang=js"

import "./DexInputNumber.vue?vue&type=style&index=0&id=6fef3d38&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__